module.exports = __webpack_public_path__ + "img/model_image.f3ddab52.png";